import React, { Component, Fragment } from 'react';
import { makeEstofexMap, legend } from './utils';

import { removeLayer } from '@ro-utils/common/helpers';

import { LAYER_ESTOFEX, LAYER_ESTOFEX_MARKER } from '@ro-utils/constant';

class Estofex extends Component {
  removeEstofexLayers() {
    removeLayer(LAYER_ESTOFEX_MARKER, this.props.map);
    removeLayer(LAYER_ESTOFEX, this.props.map);
  }
  componentDidMount() {
    const { data, settings } = this.props;
    this.removeEstofexLayers();
    this.setEstofexData(data, settings);
  }
  setEstofexData(data, settings) {
    const { map } = this.props;
    makeEstofexMap(data, legend, map, settings);
  }

  parseAlpha(alpha) {
    return parseInt(alpha, 10) / 100;
  }

  componentWillReceiveProps(nextProps) {
    const { data, settings } = this.props;
    const { data: newData, settings: newSettings } = nextProps;
    if (!newData) {
      this.removeEstofexLayers();
    }
    if (
      (newData && JSON.stringify(data) !== JSON.stringify(newData)) ||
      newSettings.opacityFill !== settings.opacityFill ||
      newSettings.opacityStroke !== settings.opacityStroke
    ) {
      this.removeEstofexLayers();
      this.setEstofexData(newData, newSettings);
    }
  }
  shouldComponentUpdate(nextProps) {
    const { data } = this.props;
    const { data: newData } = nextProps;
    if (JSON.stringify(data) !== JSON.stringify(newData)) {
      return true;
    }
    return false;
  }
  render() {
    return <Fragment />;
  }
}

export default Estofex;
